export const QUERYPARAM_SLUG = "slug";
export const QUERYPARAM_TICKET = "ticket";
export const QUERYPARAM_MODELVIEWURL = "modelViewUrl";
export const QUERYPARAM_PLATFORMURL = "platformUrl";
export const QUERYPARAM_DISABLEFALLBACKUI = "disableFallbackUi";
export const QUERYPARAM_TEMPLATE = "template";
export const QUERYPARAM_SETTINGSURL = "g";
export const QUERYPARAM_MODELSTATEID = "modelStateId";
export const QUERYPARAM_SAVEDSTATEID = "savedStateId";
export const QUERYPARAM_CONTEXT = "context";
export const QUERYPARAM_PARAMVALUE_PREFIX = "_";
export const QUERYPARAM_UTM_SOURCE = "utm_source";
export const QUERYPARAM_UTM_MEDIUM = "utm_medium";
export const QUERYPARAM_UTM_CAMPAIGN = "utm_campaign";
export const QUERYPARAM_UTM_TERM = "utm_term";
export const QUERYPARAM_UTM_CONTENT = "utm_content";
export const QUERYPARAM_UTM_USER = "utm_user";
export const QUERYPARAM_TRACKING_DOMAIN = "trackingDomain";
export const QUERYPARAM_LOGGING_LEVEL = "loggingLevel";
export const QUERYPARAM_DEBUG = "debug";
export const QUERYPARAM_MAX_HISTORY = "maxHistory";
export const QUERYPARAM_MODEL = "model";
export const QUERYPARAM_OPENAI_API_KEY = "openaiApiKey";
export const QUERYPARAM_LANGFUSE_PUBLIC_KEY = "langfusePublicKey";
export const QUERYPARAM_LANGFUSE_SECRET_KEY = "langfuseSecretKey";
export const QUERYPARAM_LANGFUSE_BASE_URL = "langfuseBaseUrl";
export const QUERYPARAM_REDIRECT = "redirect";
export const QUERYPARAM_PROVIDER = "provider";
export const QUERYPARAM_USE_DEV_PLATFORM = "useDevPlatform";
export const QUERYPARAM_USE_STAGING_PLATFORM = "useStagingPlatform";
export const QUERYPARAM_USE_SANDBOX_PLATFORM = "useSandboxPlatform";

export const QUERYPARAM_LOCALHOST_RUNNING_IN_PLATFORM =
	"localhostRunningInPlatform";

export const DEFAULT_TRACKING_PARAMS = [
	QUERYPARAM_SLUG,
	QUERYPARAM_UTM_SOURCE,
	QUERYPARAM_UTM_MEDIUM,
	QUERYPARAM_UTM_CAMPAIGN,
	QUERYPARAM_UTM_TERM,
	QUERYPARAM_UTM_CONTENT,
	QUERYPARAM_UTM_USER,
];
